import { Platform } from 'react-native';

// Platform-specific screen resolution for Jobs
// Metro bundler will resolve .web.jsx files automatically when Platform.OS === 'web'

// JobsScreen - uses Jobs.web.jsx on web, Jobs.js on native
export const JobsScreen = Platform.select({
  web: () => require('./Jobs.web.jsx').default,
  default: () => require('./Jobs').default,
})();

// PostJobScreen - uses PostJob.web.jsx on web, PostJob.js on native
export const PostJobScreen = Platform.select({
  web: () => require('./PostJob.web.jsx').default,
  default: () => require('./PostJob').default,
})();

// JobDescriptionScreen - uses JobDescription.web.jsx on web if available
export const JobDescriptionScreen = Platform.select({
  web: () => {
    try {
      return require('./JobDescription.web.jsx').default;
    } catch (e) {
      // Fallback to Home's JobDescription if not found in Jobs
      return require('../Home/JobDescription').default;
    }
  },
  default: () => require('../Home/JobDescription').default,
})();

// MyJobsScreen - web-only screen for facility job management
export const MyJobsScreen = Platform.select({
  web: () => require('./MyJobs.web.jsx').default,
  default: () => null, // Not available on native
})();

// CandidatesScreen - web-only screen for applicant review
export const CandidatesScreen = Platform.select({
  web: () => require('./Candidates.web.jsx').default,
  default: () => null, // Not available on native
})();

// Re-export other screens for convenience
export { default as SearchFilterScreen } from './SearchFilter';
export { default as SearchLocationScreen } from './SearchLocation';
export { default as MakePaymentScreen } from './MakePayment';
export { default as SelectBankScreen } from './SelectBank';
export { default as CancelJobScreen } from './CancelJob';
